"use client";
import Image from "next/image";
import { motion, Variants } from "framer-motion";

const containerVariants: Variants = {
  hidden: {},
  visible: {
    transition: { staggerChildren: 0.2 },
  },
};

export default function AccessibleTrail() {
  return (
    <>
      <div className="bg-[#26293A] py-6 text-white">
        <div className="w-full xl:max-w-[1280px] mx-auto px-5 xl:px-2 py-14 md:py-20 flex flex-col">
          {/* 타이틀 */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.6 }}
          >
            <div className="flex flex-row items-center mb-14 md:mb-20">
              <span
                className="text-lg text-white mr-4 md:mr-10 w-9 h-9 md:w-11 md:h-11 rounded-lg md:rounded-2xl bg-[#DA6363] items-center flex justify-center"
                style={{ fontFamily: '"paperlogy-bold", sans-serif' }}
              >
                4
              </span>
              <p
                className="text-xl md:text-3xl text-white"
                style={{ fontFamily: '"paperlogy-bold", sans-serif' }}
              >
                무장애 나눔길
              </p>
            </div>
          </motion.div>
          <motion.div
            className="flex flex-col"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={containerVariants}
          >
            <motion.p
              className="mt-5 text-light-10 md:mt-12 xl:mt-16  text-2xl md:text-3xl xl:text-4xl  leading-8 md:leading-12"
              style={{ fontFamily: '"paperlogy-bold", sans-serif' }}
              variants={{
                hidden: { opacity: 0, y: 10 },
                visible: { opacity: 1, y: 0 },
              }}
              transition={{ duration: 0.5 }}
            >
              무장애나눔길, 접근성에 따라 3단계 표시!
            </motion.p>
            <motion.p
              className="text-sm-15 regular-text-24 text-xl-20 mt-5 text-light-10 tracking-tight"
              variants={{
                hidden: { opacity: 0, y: 10 },
                visible: { opacity: 1, y: 0 },
              }}
              transition={{ duration: 0.5 }}
              style={{ fontFamily: '"paperlogy-regular", sans-serif' }}
            >
              편의시설과 이동 편의 정보를 지도를 통해 쉽게 확인하세요.
            </motion.p>
          </motion.div>
          <motion.div
            className="relative w-full mx-auto my-20"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
          >
            {/* 데스크톱 이미지: md 이상에서만 보여줌 */}
            <div className="relative w-full aspect-[1268/935] max-h-[940px] hidden md:block">
              <Image
                src="/assets/images/page/service/wemap/accessibleWeb.svg"
                alt="wemap screen desktop"
                fill
                className="object-contain object-right-top"
              />
            </div>

            {/* 모바일 이미지: md 이하에서만 보여줌 */}
            <div className="relative w-full aspect-[337/1778] max-h-[1070px] md:hidden">
              <Image
                src="/assets/images/page/service/wemap/accessibleMobile.svg"
                alt="wemap screen mobile"
                fill
                className="object-contain object-top"
              />
            </div>
          </motion.div>
        </div>
      </div>
      {/* 라운드 */}
      <div className="relative h-10 md:h-32 ">
        <div className="absolute inset-0 bg-[#131521] z-0" />
        <div className="absolute inset-x-0 top-0  h-10 md:h32 bg-[#26293A] rounded-b-[40px] md:rounded-b-[120px] z-10 pt-10 md:pt-32" />
      </div>
      {/* 하단 섹션 */}
      <div className="bg-[#131521] text-center py-32 px-5">
        <p
          className="text-2xl md:text-4xl text-[#565968] leading-9 md:leading-14 tracking-normal"
          style={{ fontFamily: '"paperlogy-bold", sans-serif' }}
        >
          하나, 하나의 공간 정보가 모여
          <span className="sm:hidden"> </span>{" "}
          <br className="hidden sm:inline" />
          누군가에게 삶의 영역이 확장되고,
          <span className="sm:hidden"> </span>
          <br className="hidden sm:inline" />더 나아가 우리 사회에 좋은 인식이
          뿌리내리길 희망합니다.
        </p>
      </div>
    </>
  );
}
